<template>
	<v-dialog v-model="showDialog" width="500" min-height="400" persistent>
		<v-card>
			<v-overlay :absolute="true" :value="loading"></v-overlay>
			<v-card-title> Reference List Type </v-card-title>
			<v-card-text>
				<v-text-field
					ref="Id"
					class="d-none"
					label="Id"
					v-model="referenceTypeId"
					:rules="[rules.required]"
					hide-details="auto"
				>
				</v-text-field>
				<v-text-field
					ref="Name"
					label="Name"
					autofocus
					v-model="referenceTypeName"
					:rules="[rules.required]"
					hide-details="auto"
					@keydown.enter="onSave"
				>
				</v-text-field>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn @click.stop="onClose">Close</v-btn>
				<v-btn @click.stop="onSave" color="primary">
					<v-icon class="mr-2">mdi-content-save</v-icon>
					Save
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { ReferenceListsActions } from '../../../store/actions';

export default {
	name: 'ReferenceTypeDialog',
	props: {
		showDialog: Boolean,
		action: String,
		item: Object,
	},
	computed: {
		insertForm() {
			return {
				Name: this.referenceTypeName,
			};
		},

		form() {
			return {
				Id: this.referenceTypeId,
				Name: this.referenceTypeName,
			};
		},
	},
	data() {
		return {
			loading: false,
			referenceTypeId: null,
			referenceTypeName: '',
			rules: {
				required: (value) => !!value || 'Field is required',
			},
		};
	},
	mounted() {
		if (this.item) {
			this.referenceTypeId = this.item.Id;
			this.referenceTypeName = this.item.Name;
		}
	},
	methods: {
		onClose() {
			this.$emit('close');
		},
		onSave() {
			let storeAction = null;
			let form = null;
			if (this.action === 'add') {
				storeAction = ReferenceListsActions.ADD_REFERENCE_LIST_TYPE;
				form = this.insertForm;
			}

			if (this.action === 'edit') {
				storeAction = ReferenceListsActions.UPDATE_REFERENCE_LIST_TYPE;
				form = this.form;
			}
			if (!form) return;
			if (!this.validateForm(form)) return;
			this.loading = true;
			this.$store
				.dispatch(storeAction, form)
				.then(() => {
					this.loading = false;
					this.$emit('close');
				})
				.catch(() => {
					this.loading = false;
				});
		},
		clearDialog() {
			this.referenceTypeName = null;
			this.resetValidation();
		},

		validateForm(form) {
			let formHasErrors = false;
			Object.keys(form).forEach((f) => {
				if (!form[f]) formHasErrors = true;
				this.$refs[f].validate(true);
			});
			return !formHasErrors;
		},
		resetValidation() {
			Object.keys(this.form).forEach((f) => {
				this.$refs[f].reset();
			});
		},
	},
};
</script>
